import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./outlet/outlet.routes').then((mod) => mod.OutLet),
  },
  {
    path: 'supplier-new',
    loadChildren: () =>
      import('./screens/supplier/supplier.router').then(
        (mod) => mod.supplierRouter
      ),
  },
  {
    path: 'delete-account',
    loadComponent: () =>
      import(
        './playstore-account-delete/user-delete/user-delete.component'
      ).then((c) => c.UserDeleteComponent),
  },

  {
    path: 'new-user',
    loadComponent: () =>
      import(
        './account/new-userlogin/new-userlogin.component'
      ).then((c) => c.NewUserloginComponent),
  },
  /* {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./account/privacy-policy/privacy-policy.component').then(
        (m) => m.PrivacyPolicyComponent
      ),
  }, */
  // {
  //     path: 'delete-account',
  //     loadChildren: () =>
  //         import('./playstore-account-delete/playstore-account-delete').then(
  //             (m) => m.UserDeleteRoute
  //         ),
  // },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/pagenotfound/pagenotfound.component').then(
        (m) => m.PagenotfoundComponent
      ),
  },
];
